import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { SachLoginService } from '../../../services/sach-login.service';
import { UserDetailsService } from '../../../services/user-details.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css'],
})
export class LoginPageComponent {
  accessToken: string = '';
  loginDetails: any;
  url = environment.oneLogUrl;

  constructor(
    private sachLoginService: SachLoginService,
    private router: Router,
    private userService: UserDetailsService,
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const token = params['token'];
      const access = params['access'];
      if (token && access){
        this.accessToken = access;
        this.login();
        localStorage.setItem('auth_token', token);
        
      }
    })
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/report/published-reports']);
    }
  }

  login() {
    if (this.accessToken == '') {
      alert('Please enter access token');
      return 0;
    }

    return this.sachLoginService
      .login(this.accessToken)
      .subscribe((data: {}) => {
        this.loginDetails = data;
        if (this.loginDetails.access_token) {
          this.userService.setUserDetails(
            this.loginDetails.access_token,
            this.loginDetails.user_id,
            this.accessToken
          );
          //this.router.navigate(['/list-products'])
          this.router.navigate(['/list-reports']);
        }
      });
  }

  microsoftLogin(){
    window.location.href= this.url + '/login/microsoft';
  }
}
